import { __assign, __extends } from "tslib";
/**
 * Created by Liana.Ulianovskaia on 2018-08-29.
 * develop 2
 */
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import BSSDynamicContentAccordionComponent from '../../bss-accordion-component/js/bss-accordion-component--dynamic-content.js';
import listBoxContainerTemplate from '../template/list-box-container.hbs';
import listBoxTemplate from '../template/list-box.hbs';
import listVariantTemplate from '../template/list-variant.hbs';
import BSSInfoHintComponent from '../../bss-infohint-component/js/bss-infohint-component.js';
import helper from '@main/externals/bss-package-helper/js/helper';
import logger from '@main/externals/bss-package-logger/js/logger';
/**
 * BSSListBoxComponent class
 */
var templateObject = {
    defaultTemplate: listBoxContainerTemplate,
};
var BSSListBoxComponent = /** @class */ (function (_super) {
    __extends(BSSListBoxComponent, _super);
    /**
     *
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] config configuration of component
     * @param {EventManager} [eventManager=null] instance of _EventManager
     * @param {Formatter} [formatter=null] instance of Formatter
     * @param {Resolution} [resolution=null] Resolution class for width breakpoint handling
     * @param {Toolbox} [toolbox=null] instance of Toolbox object
     */
    function BSSListBoxComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templateObject, toolbox) || this;
        /**
         * @desc set error flag for the entity error
         * @private
         */
        _this._setErrorFlag = function () {
            logger.info('BSSListBoxComponent ' +
                _this._config.componentId +
                ' => function : _setErrorFlag');
            _this._isEntityError = true;
        };
        /**
         * @desc on details accordion click - prepare data for request and send an event to controller
         * @param {String} name - publisher name
         * @param {Object} data - event data
         * @emits {bss-list-box-send-request-for-Details-on-budget-calculator}
         * @private
         */
        _this._prepareDataForDetailsRequest = function (name, data) {
            if (name === void 0) { name = null; }
            if (data === void 0) { data = null; }
            logger.info('BSSListBoxComponent ' +
                _this._config.componentId +
                ' => function : _prepareDataForDetailsRequest | Params: ', name, data);
            _this._isEntityError = false;
            var carId = data.carId || null;
            var productId = _this._config.productId[0];
            var resultData = _this._config.resultData[productId];
            var resultDataFlat = _this._toolbox.resultDataFlat[productId];
            if (carId) {
                _this._eventManager.publish('bss-list-box-send-request-for-Details-on-budget-calculator', 'bss-list-box', { resultData: resultData, carId: carId }, false);
                var variantsList = resultData.variantsList || [];
                var variantsCarIndex = helper.findIndexWithMatchingId(variantsList, carId);
                var carData = variantsList[variantsCarIndex] || {};
                resultDataFlat.gradeName = carData.grade || '';
                resultDataFlat.priceDisplay = carData.from || '';
            }
        };
        /**
         * @desc on financial details accordion click - prepare data for request and send an event to controller
         * @param {String} name - publisher name
         * @param {Object} data - event data
         * @emits {bss-list-box-send-request-for-FinancialDetails-on-budget-calculator}
         * @private
         */
        _this._prepareDataForFinancialDetailsRequest = function (name, data) {
            if (name === void 0) { name = null; }
            if (data === void 0) { data = null; }
            logger.info('BSSListBoxComponent ' +
                _this._config.componentId +
                ' => function : _prepareDataForFinancialDetailsRequest | Params: ', name, data);
            _this._isEntityError = false;
            var carId = data.carId || null;
            var resultData = _this._config.resultData[_this._config.productId[0]];
            var resultDataFlat = _this._toolbox.resultDataFlat[_this._config.productId[0]];
            if (_this._config.isVariantList) {
                _this._eventManager.publish('bss-list-box-send-request-for-FinancialDetails-on-budget-calculator', 'bss-list-box', {
                    resultData: resultData,
                    modelId: resultData.modelId,
                    carId: carId,
                }, false);
                var variantsList = (resultData === null || resultData === void 0 ? void 0 : resultData.variantsList) || [];
                var variantsCarIndex = helper.findIndexWithMatchingId(variantsList, carId);
                var carData = variantsList[variantsCarIndex] || {};
                resultDataFlat.gradeName = carData.grade || '';
                resultDataFlat.priceDisplay = carData.from || '';
                resultDataFlat.modelName = carData.modelName || '';
            }
            else {
                _this._eventManager.publish('bss-list-box-send-request-for-FinancialDetails-on-budget-calculator', 'bss-list-box', {
                    resultData: resultData,
                    modelId: carId,
                }, false);
                var modelsList = (resultData === null || resultData === void 0 ? void 0 : resultData.modelsList) || [];
                var modelsCarIndex = helper.findIndexWithMatchingId(modelsList, carId);
                var carData = modelsList[modelsCarIndex] || {};
                resultDataFlat.modelName = (carData === null || carData === void 0 ? void 0 : carData.name) || '';
            }
        };
        /**
         * @desc show more items on load more click
         * @param {Event} e event object
         * @private
         */
        _this._onLoadMoreClick = function (e) {
            e.preventDefault();
            var hiddenListBoxItems = _this._$componentEl.find('.bss-list-box_item.hidden');
            hiddenListBoxItems
                .slice(0, _this._numListBoxItemsOnLoadMore)
                .removeClass('hidden')
                .slideDown();
            if (hiddenListBoxItems.length <= _this._numListBoxItemsOnLoadMore &&
                _this._$loadMoreBtn.length) {
                _this._$loadMoreBtn.addClass('hidden');
            }
        };
        if (_this._config.hintText || _this._config.hintTitle) {
            _this._infohint = new BSSInfoHintComponent(_entityTemplate, '.' + _this._config.componentId + '_info-hint-container', config, eventManager, formatter, resolution, toolbox);
        }
        _this._componentVersion = '@@name ver. @@version';
        /**
         * @desc listBox component template
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._listBoxComponentTemplate = null;
        _this._isInPopup = _this._toolbox
            .$('.modal-body')
            .has('#' + _this._componentScope.attr('id')).length;
        _this._scrollContainer = _this._isInPopup
            ? _this._toolbox.$('.modal-body')
            : _this._toolbox.$(document.scrollingElement || document.documentElement);
        _this._viewportContainer = _this._isInPopup
            ? _this._scrollContainer
            : _this._window;
        _this._fixedBar = _this._componentScope.find('.bss-list-box_header');
        _this._scrollOnModelsView = null;
        _this._scrollOnVariantsView = null;
        /**
         * @desc flag for entity error
         * @type {boolean}
         * @private
         */
        _this._isEntityError = false;
        /**
         * @desc number of car boxes added on every load more click
         * @type {Number}
         * @private
         */
        _this._numListBoxItemsOnLoadMore = 6;
        /**
         * @desc details and financial details configuration node names in uiDesc
         * @type {Object}
         * @private
         */
        _this._accordionsConfig = ['detailsConfig', 'financialDetailsConfig'];
        _this._viewportContainer
            .off('scroll.listBox_' + _this._componentScope.attr('id'))
            .on('scroll.listBox_' + _this._componentScope.attr('id'), _this._setFixedBarPosition.bind(_this));
        _this._window
            .off('resize.listBox_' + _this._config.componentId)
            .on('resize.listBox_' + _this._config.componentId, _this._setFixedBarAllParams.bind(_this));
        _this._eventManager.subscribe('bss-filter-component-changed-height', _this._setFixedBarAllParams.bind(_this), "".concat(_this.subscriberPrefix).concat(_this._config.componentId));
        logger.info('ListBoxComponent ' +
            _this._config.componentId +
            ' has been successful render');
        _this._eventManager.subscribe('bss-entity-created-' + _this._config.entityInstanceId, _this.viewUpdate.bind(_this), "".concat(_this.subscriberPrefix).concat(_this._config.componentId));
        _this._injectDynamicAccordions(_this._accordionsConfig);
        _this._prepareListBoxItems();
        return _this;
    }
    /**
     * Resize window to recalculate view when its content is ready
     */
    BSSListBoxComponent.prototype.viewUpdate = function () {
        var _this = this;
        setTimeout(function () {
            _this._window.trigger('resize');
        }, 1000);
    };
    /**
     * @desc base destroy method
     */
    BSSListBoxComponent.prototype.destroy = function () {
        logger.info('BSSListBoxComponent: ' +
            this._config.componentId +
            ' => function : destroy');
        if (typeof this._infohint !== 'undefined') {
            this._infohint.destroy();
        }
        this._entityTemplate.find(this._containerSelector).html('');
        _super.prototype.destroy.call(this);
    };
    /**
     * Overridden
     * BSSAbstractComponent _setConfig method override
     * @param {Object} config configuration
     * @private
     */
    BSSListBoxComponent.prototype.setConfig = function (config) {
        _super.prototype.setConfig.call(this, config);
        if (config.hasOwnProperty('boxConfig') && config.boxConfig) {
            /**
             * Configuration for list of boxed
             * @type {Object}
             * @private
             */
            this._boxConfig = {
                btnText: config.boxConfig.hasOwnProperty('btnText')
                    ? config.boxConfig.btnText
                    : '',
                disclaimer: config.boxConfig.hasOwnProperty('disclaimer')
                    ? config.boxConfig.disclaimer
                    : '',
                additionalText: config.boxConfig.hasOwnProperty('additionalText')
                    ? config.boxConfig.additionalText
                    : '',
                campaignText: config.boxConfig.hasOwnProperty('campaignText')
                    ? config.boxConfig.campaignText
                    : '',
                matches: config.boxConfig.hasOwnProperty('matches')
                    ? config.boxConfig.moreText
                    : 0,
                moreText: config.boxConfig.hasOwnProperty('moreText')
                    ? config.boxConfig.moreText
                    : '',
                more2Text: config.boxConfig.hasOwnProperty('more2Text')
                    ? config.boxConfig.more2Text
                    : '',
                btnDetailsText: config.boxConfig.hasOwnProperty('btnDetailsText')
                    ? config.boxConfig.btnDetailsText
                    : '',
                btnPdfText: config.boxConfig.hasOwnProperty('btnPdfText')
                    ? config.boxConfig.btnPdfText
                    : '',
                btnCustomizeText: config.boxConfig.hasOwnProperty('btnCustomizeText')
                    ? config.boxConfig.btnCustomizeText
                    : '',
                btnFinancialText: config.boxConfig.hasOwnProperty('btnFinancialText')
                    ? config.boxConfig.btnFinancialText
                    : '',
                btnLoadMoreText: config.boxConfig.hasOwnProperty('btnLoadMoreText')
                    ? config.boxConfig.btnLoadMoreText
                    : '',
            };
            this._prepareBoxListConfig();
        }
    };
    /**
     * @desc set component template
     * BSSAbstractComponent _setComponentTemplate method override
     * @public
     */
    BSSListBoxComponent.prototype.setTemplate = function () {
        logger.info('BSSListBoxComponent: ' +
            this._config.componentId +
            ' => function : setTemplate');
        // Set default container template
        _super.prototype.setTemplate.call(this);
        // Set box-list template
        if (this._config.isVariantList) {
            this._listVariantComponentTemplate = this._toolbox.$(listVariantTemplate(this._boxConfig));
        }
        else {
            this._listBoxComponentTemplate = this._toolbox.$(listBoxTemplate(this._boxConfig));
        }
        this._$componentContent = this._toolbox.$('#' +
            this._config.containerId +
            ' #bss-list-box_list-' +
            this._config.componentId);
        this._$componentHeader = this._toolbox.$('#' +
            this._config.containerId +
            ' #bss-list-box_header-' +
            this._config.componentId);
        this._$componentEmptyHeader = this._toolbox.$('#' +
            this._config.containerId +
            ' #bss-list-box_empty-' +
            this._config.componentId);
        if ((this._listVariantComponentTemplate &&
            this._listVariantComponentTemplate.length) ||
            (this._listBoxComponentTemplate && this._listBoxComponentTemplate.length)) {
            this._$componentEmptyHeader.css('display', 'none');
            this._$componentContent.css('display', 'flex');
        }
        else {
            this._$componentEmptyHeader.css('display', 'block');
            this._$componentContent.css('display', 'none');
        }
        this._setBoxTemplate();
        this._initializeTaggingListBox();
    };
    /**
     * @desc check if slider limits changed modifies updateObject(data) and fires super method
     * BSSAbstractComponent _setComponentTemplate method override
     * @param {String} publisherName - event owner name
     * @param {Object} data - updateObject holds new text and dataResult
     * @emits {bss-component-data-rebound-$COMPONENT-ID'}
     * @emits {bss-accordion-disable}
     * @private
     */
    BSSListBoxComponent.prototype.update = function (publisherName, data) {
        logger.info('BSSListBoxComponent:: ' +
            this._config.componentId +
            ' => function : _update' +
            ' | Params: ', publisherName, data);
        var resultData = data.resultData[this._config.productId[0]];
        // save update timestap - for component-critical-error handling
        this._lastUpdateTimestamp = data.updateTimestamp;
        // if there is regular update event (not revert state) and critical error was thrown, do not update this component!
        if (this._stopUpdateFlag && !this._isRevertStateEvent) {
            this._stopUpdateFlag = false;
            if (typeof resultData.error_code !== 'undefined') {
                this.setErrorObject({
                    errorMsg: 'config -> there is no complete set of data',
                    errorSeverity: 'critical',
                });
                this._onCriticalError(this._errorObj);
            }
            return;
        }
        this._resetErrorObject();
        this._isRevertStateEvent = false;
        // if entity error - send event to accordion to unbind click to disable accordion, do not refresh data
        if (this._isEntityError) {
            this._eventManager.publish('bss-accordion-disable', 'bss-list-box');
            return;
        }
        // details or financial details accordion click - do not refresh data, but send event to show accordion content
        if (resultData.details) {
            this._sendEventForAccordionContent(resultData);
            return;
        }
        this.preventUpdateEvent = true;
        if (this._config.productId[0] === 'general') {
            this.productIterator = this._config.productId.length - 1;
        }
        else {
            this.productIterator = 0;
        }
        this._prepareBoxListConfig(data.resultData);
        this.setTemplate();
        this._injectDynamicAccordions(this._accordionsConfig);
        this._validateDataOnChange(data, true, true);
        this._prepareListBoxItems();
        if (this._tagEventOnThrow !== null) {
            this._throwTaggingEvent(this._tagEventOnThrow, true);
            this._tagEventOnThrow = null;
        }
        this.preventUpdateEvent = false;
        this._eventManager.publish('bss-component-data-rebound-' + this._config.componentId, this._config.componentType + '-' + this._config.componentId, data);
    };
    /**
     * @desc send event for accordion content show
     * @param {Object} resultData - resultData object
     * @emits {bss-accordion-show-content}
     * @private
     */
    BSSListBoxComponent.prototype._sendEventForAccordionContent = function (resultData) {
        logger.info('BSSListBoxComponent ' +
            this._config.componentId +
            ' => function : _sendEventForAccordionContent | Params: ', resultData);
        var variantsList = resultData.variantsList || null;
        var modelsList = resultData.modelsList || null;
        var globalTexts = this._config.texts.general;
        // send event for accordion content display only for the current view
        if ((this._config.isVariantList && (variantsList === null || variantsList === void 0 ? void 0 : variantsList.length)) ||
            (!this._config.isVariantList && (modelsList === null || modelsList === void 0 ? void 0 : modelsList.length))) {
            this._eventManager.publish('bss-accordion-show-content', 'bss-list-box', {
                resultData: resultData,
                globalTexts: globalTexts,
            });
        }
    };
    /**
     * @desc append dynamic components: details button as accordion and financial button as accordion
     * @param {Object} accordionsConfig - accordions configuration
     * @private
     */
    BSSListBoxComponent.prototype._injectDynamicAccordions = function (accordionsConfig) {
        logger.info('BSSListBoxComponent ' +
            this._config.componentId +
            ' => function : _injectDynamicAccordions | Params: ', accordionsConfig);
        for (var boxIndex in this._boxListResultData) {
            if (this._boxListResultData.hasOwnProperty(boxIndex)) {
                var carId = this._boxListResultData[boxIndex].id;
                // loop injected accordions
                for (var _i = 0, _a = this._accordionsConfig; _i < _a.length; _i++) {
                    var injectedElConfig = _a[_i];
                    // check if definition for an injected accordion exists in uidescription
                    if (Object.keys(this._config[injectedElConfig]).length) {
                        var detailsConfig = this._toolbox._.cloneDeep(this._config[injectedElConfig]);
                        var detailsContainerIdPrefix = detailsConfig.containerIdPrefix;
                        var detailsContainer = "".concat(detailsContainerIdPrefix, "-").concat(carId);
                        var detailsContainerSelector = "#".concat(detailsContainer);
                        // check if a container for an accorion exists
                        if (this._toolbox.$(detailsContainerSelector).length) {
                            var detailsComponentIdPrefix = detailsConfig.componentIdPrefix;
                            detailsConfig.componentId =
                                detailsComponentIdPrefix + '-' + carId;
                            detailsConfig.containerId = detailsContainer;
                            detailsConfig.carId = carId;
                            this._setAccordionTitle(detailsConfig);
                            this._setAccordionListeners(detailsConfig, carId);
                            new BSSDynamicContentAccordionComponent(this._entityTemplate, detailsContainerSelector, detailsConfig, this._eventManager, this._formatter, this._resolution, this._toolbox);
                        }
                    }
                }
            }
        }
    };
    /**
     * @desc set accordion title
     * @param {Object} detailsConfig - uiDesc configuration for the accordion
     * @private
     */
    BSSListBoxComponent.prototype._setAccordionTitle = function (detailsConfig) {
        var title = detailsConfig.title;
        var paramName = title && title.split('.')[1];
        var paramValue = paramName && this._config.texts.general[paramName];
        detailsConfig.title = paramValue || null;
    };
    /**
     * @desc set accordions listeners
     * @param {Object} detailsConfig - uiDesc configuration for the accordion
     * @param {Object} carId - car id
     * @listens {bss-list-box-prepareData-for-request-$ACCORDION_NAME-$CAR_ID}
     * @listens {bss-entity-error-$ENTITY-INSTANCE-ID}
     * @private
     */
    BSSListBoxComponent.prototype._setAccordionListeners = function (detailsConfig, carId) {
        logger.info('BSSListBoxComponent ' +
            this._config.componentId +
            ' => function : _setAccordionListeners | Params: ', detailsConfig, carId);
        this._eventManager.unsubscribe("bss-entity-error-".concat(this._config.entityInstanceId), this._setErrorFlag, "".concat(this.subscriberPrefix).concat(this._config.componentId));
        this._eventManager.subscribe("bss-entity-error-".concat(this._config.entityInstanceId), this._setErrorFlag, "".concat(this.subscriberPrefix).concat(this._config.componentId));
        if (detailsConfig.elementType === 'bcDetails') {
            this._eventManager.unsubscribe("bss-list-box-prepareData-for-request-".concat(detailsConfig.elementType, "-").concat(carId), this._prepareDataForDetailsRequest, "".concat(this.subscriberPrefix).concat(this._config.componentId));
            this._eventManager.subscribe("bss-list-box-prepareData-for-request-".concat(detailsConfig.elementType, "-").concat(carId), this._prepareDataForDetailsRequest, "".concat(this.subscriberPrefix).concat(this._config.componentId));
        }
        if (detailsConfig.elementType === 'bcFinancialDetails') {
            this._eventManager.unsubscribe("bss-list-box-prepareData-for-request-".concat(detailsConfig.elementType, "-").concat(carId), this._prepareDataForFinancialDetailsRequest, "".concat(this.subscriberPrefix).concat(this._config.componentId));
            this._eventManager.subscribe("bss-list-box-prepareData-for-request-".concat(detailsConfig.elementType, "-").concat(carId), this._prepareDataForFinancialDetailsRequest, "".concat(this.subscriberPrefix).concat(this._config.componentId));
        }
    };
    /**
     * @desc update scroll positions on initial views: model & variant
     * @private
     */
    BSSListBoxComponent.prototype._updateScrolls = function () {
        logger.info('BSSListBoxComponent: ' +
            this._config.componentId +
            ' => function : _updateScrolls');
        var isModelList = !!this._config.resultData[this._config.productId[0]].modelsList;
        if (isModelList && this._scrollOnModelsView) {
            this._scrollContainer.scrollTop(this._scrollOnModelsView);
            this._scrollOnModelsView = null;
        }
        else if (!isModelList && this._scrollOnVariantsView) {
            this._scrollContainer.scrollTop(this._scrollOnVariantsView);
            this._scrollOnVariantsView = null;
        }
    };
    /**
     * @desc set fixed bar position
     * @private
     */
    BSSListBoxComponent.prototype._setFixedBarPosition = function () {
        var bottom = 0;
        var fixedBarOffsetCondition = this._isInPopup
            ? this._componentScope.position().top +
                parseInt(this._scrollContainer.css('paddingTop')) +
                this._fixedBar.outerHeight()
            : this._componentScope.offset().top + this._fixedBar.outerHeight();
        if (this._viewportContainer.outerHeight() +
            this._scrollContainer.scrollTop() >=
            fixedBarOffsetCondition) {
            this._fixedBar.addClass('mocked').css({
                position: 'absolute',
                bottom: 'auto',
            });
        }
        else {
            if (this._isInPopup) {
                bottom = parseInt(this._componentScope
                    .closest('.modal-content')
                    .css('borderBottomWidth'));
            }
            this._fixedBar.removeClass('mocked').css({
                position: 'fixed',
                bottom: bottom,
            });
        }
    };
    /**
     * @desc set fixed bar size
     * @private
     */
    BSSListBoxComponent.prototype._setFixedBarAllParams = function () {
        var fixedBarParentEl = this._fixedBar.parent();
        var fixedBarParentElWidth = fixedBarParentEl.width();
        var fixedBarNextEl = this._fixedBar.next();
        this._fixedBar.css({
            width: fixedBarParentElWidth,
        });
        if (fixedBarNextEl.is('.bss-list-box_content')) {
            fixedBarNextEl.css({
                width: fixedBarParentElWidth,
            });
        }
        this._componentScope.find('.bss-list-box_list').css({
            'margin-top': this._fixedBar.outerHeight(),
        });
        this._setFixedBarPosition();
    };
    /**
     * @desc prepares component for data binding
     * @private
     */
    BSSListBoxComponent.prototype._prepareBoxListConfig = function (resultData) {
        if (resultData === void 0) { resultData = this._config.resultData; }
        logger.info('BSSListBoxComponent: ' +
            this._config.componentId +
            ' => function : _prepareBoxListConfig');
        var productResultData = resultData[this._config.productId[0]];
        var productResultDataBrand = productResultData.brand || '';
        var brand = productResultDataBrand
            ? productResultDataBrand[0].toUpperCase() +
                productResultDataBrand.slice(1)
            : '';
        this._boxListResultData = productResultData[this._config.valueDataParam];
        var infoBoxListParams = this._config.infoBoxListParams;
        var globalTexts = this._config.texts;
        var infoValue;
        var additionalAmountValue = 0;
        var monthlyPaymentValue = 0;
        this._boxConfig.boxList = [];
        for (var boxIndex in this._boxListResultData) {
            if (this._boxListResultData.hasOwnProperty(boxIndex)) {
                additionalAmountValue =
                    this._boxListResultData[boxIndex].additionalAmount;
                monthlyPaymentValue = this._boxListResultData[boxIndex].from;
                if (this._config.boxConfig) {
                    if (this._config.boxConfig.additionalAmountFormatter) {
                        additionalAmountValue = this._formatter.getFormattedValue(additionalAmountValue, this._config.boxConfig.additionalAmountFormatter);
                    }
                    if (this._config.boxConfig.monthlyPaymentFormatter) {
                        monthlyPaymentValue = this._formatter.getFormattedValue(monthlyPaymentValue, this._config.boxConfig.monthlyPaymentFormatter);
                    }
                }
                var model = this._boxListResultData[boxIndex].name || productResultData.modelName;
                model = model
                    ? model.replace(new RegExp(brand.toLowerCase(), 'i'), '').trim()
                    : '';
                var grade = this._boxListResultData[boxIndex].grade || '';
                // Bind box list base parameters
                this._boxConfig.boxList[boxIndex] = {
                    id: this._boxListResultData[boxIndex].id,
                    image: this._boxListResultData[boxIndex].image,
                    alt: "".concat(brand, " ").concat(model, " ").concat(grade).trim(),
                    name: this._boxListResultData[boxIndex].name,
                    nameAttr: this._boxListResultData[boxIndex].name
                        ? this._boxListResultData[boxIndex].name
                            .toLowerCase()
                            .split(' ')
                            .join('-')
                        : '',
                    grade: this._boxListResultData[boxIndex].grade,
                    link: this._boxListResultData[boxIndex].link,
                    detailsLink: this._boxListResultData[boxIndex].detailsLink,
                    pdfLink: this._boxListResultData[boxIndex].pdfLink,
                    customizeLink: this._boxListResultData[boxIndex].customizeLink,
                    additional: !!this._boxListResultData[boxIndex].additional,
                    additionalAmount: additionalAmountValue ? additionalAmountValue : 0,
                    monthlyPayment: monthlyPaymentValue ? monthlyPaymentValue : 0,
                    hybridIsAvailable: !!this._boxListResultData[boxIndex].hybridIsAvailable,
                    campaignIsAvailable: !!this._boxListResultData[boxIndex].campaignIsAvailable,
                    matches: this._boxListResultData[boxIndex].matches,
                    bodyType: this._boxListResultData[boxIndex].bodyType,
                    engine: this._boxListResultData[boxIndex].engine,
                    transmission: this._boxListResultData[boxIndex].transmission,
                    paramList: [],
                };
                // Bind info box list parameters data
                for (var infoParamName in infoBoxListParams) {
                    if (infoBoxListParams.hasOwnProperty(infoParamName)) {
                        var infoText = infoBoxListParams[infoParamName].text.split('.');
                        var product = infoText[0];
                        var variable = infoText[1];
                        infoValue = this._boxListResultData[boxIndex][infoParamName];
                        if (infoBoxListParams[infoParamName].formatter) {
                            infoValue = this._formatter.getFormattedValue(infoValue, infoBoxListParams[infoParamName].formatter);
                        }
                        this._boxConfig.boxList[boxIndex].paramList.push({
                            text: globalTexts[product][variable],
                            value: infoValue,
                        });
                    }
                }
            }
        }
    };
    /**
     * @desc prepares box list component for data binding
     * @private
     */
    BSSListBoxComponent.prototype._setBoxTemplate = function () {
        var _this = this;
        logger.info('BSSListBoxComponent: ' +
            this._config.componentId +
            ' => function : _setBoxTemplate | Param');
        var componentTemplate = this._config.isVariantList
            ? this._listVariantComponentTemplate
            : this._listBoxComponentTemplate;
        this._$componentContent.html(componentTemplate);
        setTimeout(function () {
            // push the code to the bottom of the stack, because browser's renderering is asynchronous
            _this._updateScrolls();
            _this._setFixedBarAllParams();
        }, 0);
        this._$componentContent
            .find('.bss-list-box_btn')
            .off('click.' + this._config.componentId)
            .on('click.' + this._config.componentId, this._onClickEvent.bind(this));
        this._$componentHeader
            .find('.bss-list-box_btn')
            .off('click.' + this._config.componentId)
            .on('click.' + this._config.componentId, this._onClickEvent.bind(this));
        this._$componentContent
            .find('.bss-list-box_item-seeFinancial-btn')
            .off('click.' + this._config.componentId)
            .on('click.' + this._config.componentId, this._onClickEvent.bind(this));
    };
    /**
     * @desc publish event from configuration, print window view if print params set
     * @private
     */
    BSSListBoxComponent.prototype._onClickEvent = function (ev) {
        logger.info('BSSListBoxComponent: ' +
            this._config.componentId +
            ' => function : _onClickEvent | Params: ', ev);
        var $button = this._toolbox.$(ev.currentTarget);
        var dataId = $button.closest('.bss-list-box_item').attr('data-id');
        var index = $button.closest('.bss-list-box_item').attr('data-index');
        var resultData = this._config.resultData[this._config.productId[0]];
        if ($button.hasClass('bss-list-box_seeAll-btn')) {
            this._eventManager.publish('bss-list-box-open-list', 'bss-list-box', {
                modelId: dataId,
            });
            this._scrollOnModelsView = this._scrollContainer.scrollTop();
            this._scrollOnVariantsView = this._isInPopup
                ? this._componentScope.find('.bss-list-box_content').position().top
                : this._componentScope.find('.bss-list-box_content').offset().top;
            this._modelId = dataId;
        }
        else if ($button.hasClass('bss-list-box_pdf-btn')) {
            var totalPrice = this._boxListResultData[index].carPriceInclDelivery;
            var quoteId = this._boxListResultData[index].quoteId;
            var _a = this._boxListResultData[index].exteriorColourId, exteriorColourId = _a === void 0 ? null : _a;
            var _b = this._boxListResultData[index].upholsteryId, upholsteryId = _b === void 0 ? null : _b;
            this._carId = dataId;
            this._modelId = resultData.modelId;
            this._eventManager.publish('bss-list-box-open-cta', 'bss-list-box', {
                carId: dataId,
                modelId: resultData.modelId,
                country: resultData.country,
                brand: resultData.brand,
                language: resultData.language,
                totalPrice: totalPrice,
                quoteId: quoteId,
                exteriorColourId: exteriorColourId,
                upholsteryId: upholsteryId,
                type: 'getPdf',
                tagging: true,
            }, false);
            this._toolbox.resultDataFlat[this._config.productId[0]].ctaName =
                'budget-download-pdf';
            this._toolbox.resultDataFlat[this._config.productId[0]].carId = dataId;
            this._toolbox.resultDataFlat[this._config.productId[0]].productName =
                this._boxListResultData[index].productName;
            this._toolbox.resultDataFlat[this._config.productId[0]].hybridIsAvailable = this._boxListResultData[index].hybridIsAvailable
                ? 1
                : 0;
            this._toolbox.resultDataFlat[this._config.productId[0]].bodyType =
                this._boxListResultData[index].bodyType;
            this._toolbox.resultDataFlat[this._config.productId[0]].engine =
                this._boxListResultData[index].engine;
            this._toolbox.resultDataFlat[this._config.productId[0]].transmission =
                this._boxListResultData[index].transmission;
            this._toolbox.resultDataFlat[this._config.productId[0]].totalPrice =
                this._boxListResultData[index].carPriceInclDelivery;
            this._toolbox.resultDataFlat[this._config.productId[0]].duration =
                this._boxListResultData[index].duration;
            this._toolbox.resultDataFlat[this._config.productId[0]].from =
                this._boxListResultData[index].from;
            this._toolbox.resultDataFlat[this._config.productId[0]].currency =
                resultData.currency;
            this._toolbox.resultDataFlat[this._config.productId[0]].payout =
                this._boxListResultData[index].payout;
            this._toolbox.resultDataFlat[this._config.productId[0]].totalCreditCosts =
                this._boxListResultData[index].totalCreditCosts;
        }
        else if ($button.hasClass('bss-list-box_carConfig-btn')) {
            var quoteId = this._boxListResultData[index].quoteId;
            var totalPrice = this._boxListResultData[index].carPriceInclDelivery;
            var _c = this._boxListResultData[index].exteriorColourId, exteriorColourId = _c === void 0 ? null : _c;
            var _d = this._boxListResultData[index].upholsteryId, upholsteryId = _d === void 0 ? null : _d;
            this._carId = dataId;
            this._modelId = resultData.modelId;
            this._eventManager.publish('bss-list-box-open-cta', 'bss-list-box', {
                carId: dataId,
                modelId: resultData.modelId,
                country: resultData.country,
                brand: resultData.brand,
                language: resultData.language,
                modelName: resultData.modelName,
                quoteId: quoteId,
                totalPrice: totalPrice,
                exteriorColourId: exteriorColourId,
                upholsteryId: upholsteryId,
                type: 'getUrl',
                tagging: true,
            }, false);
            this._toolbox.resultDataFlat[this._config.productId[0]].ctaName =
                'carconfigurator';
            this._toolbox.resultDataFlat[this._config.productId[0]].carId = dataId;
            this._toolbox.resultDataFlat[this._config.productId[0]].productName =
                this._boxListResultData[index].productName;
            this._toolbox.resultDataFlat[this._config.productId[0]].hybridIsAvailable = this._boxListResultData[index].hybridIsAvailable
                ? 1
                : 0;
            this._toolbox.resultDataFlat[this._config.productId[0]].bodyType =
                this._boxListResultData[index].bodyType;
            this._toolbox.resultDataFlat[this._config.productId[0]].engine =
                this._boxListResultData[index].engine;
            this._toolbox.resultDataFlat[this._config.productId[0]].transmission =
                this._boxListResultData[index].transmission;
            this._toolbox.resultDataFlat[this._config.productId[0]].totalPrice =
                this._boxListResultData[index].carPriceInclDelivery;
            this._toolbox.resultDataFlat[this._config.productId[0]].duration =
                this._boxListResultData[index].duration;
            this._toolbox.resultDataFlat[this._config.productId[0]].from =
                this._boxListResultData[index].from;
            this._toolbox.resultDataFlat[this._config.productId[0]].currency =
                resultData.currency;
            this._toolbox.resultDataFlat[this._config.productId[0]].payout =
                this._boxListResultData[index].payout;
            this._toolbox.resultDataFlat[this._config.productId[0]].totalCreditCosts =
                this._boxListResultData[index].totalCreditCosts;
        }
        else {
            this._eventManager.publish('bss-list-box-open-list', 'bss-list-box', {}, false);
        }
    };
    /**
     * @desc initialize tagging
     * @private
     */
    BSSListBoxComponent.prototype._initializeTaggingListBox = function () {
        var _a;
        logger.info('BSSListBoxComponent: ' +
            this._config.componentId +
            ' => function : _initializeTaggingListBox');
        var _b = ((_a = this._config) === null || _a === void 0 ? void 0 : _a.tagEvent) || {}, _c = _b.carConfigClickTagEvent, carConfigClickTagEvent = _c === void 0 ? null : _c, _d = _b.carModelClickTagEvent, carModelClickTagEvent = _d === void 0 ? null : _d, _e = _b.carPdfClickTagEvent, carPdfClickTagEvent = _e === void 0 ? null : _e;
        var clickTagEvent = "click.".concat(this._config.componentId, ".tag");
        if (carConfigClickTagEvent) {
            this._$componentContent
                .find('.bss-list-box_carConfig-btn')
                .off(clickTagEvent)
                .on(clickTagEvent, this._onClickDoTagging.bind(this, carConfigClickTagEvent));
        }
        if (carModelClickTagEvent) {
            this._$componentContent
                .find('.bss-list-box_seeAll-btn')
                .off(clickTagEvent)
                .on(clickTagEvent, this._onClickDoTagging.bind(this, carModelClickTagEvent));
        }
        if (carPdfClickTagEvent) {
            this._$componentContent
                .find('.bss-list-box_pdf-btn')
                .off(clickTagEvent)
                .on(clickTagEvent, this._onClickDoTagging.bind(this, carPdfClickTagEvent));
        }
    };
    /**
     * @desc callback function on tagging click events
     * @param {Object} eventObject event object description from ui-desc
     * @param {Event} ev on click event object
     * @private
     */
    BSSListBoxComponent.prototype._onClickDoTagging = function (eventObject, ev) {
        logger.info("BSSListBoxComponent: ".concat(this._config.componentId, " => function : _onClickDoTagging | Params"), eventObject, ev);
        var target = ev ? this._toolbox.$(ev.currentTarget) : null;
        this._onTaggingEvent(eventObject === null || eventObject === void 0 ? void 0 : eventObject.throwEvent, eventObject === null || eventObject === void 0 ? void 0 : eventObject.throwAfterCalculation, target);
    };
    /**
     * @desc add information about carId, entity, integrationMode
     * @param {String} throwEvent
     * @param {Boolean} [recalculation=false]
     * @param {jQuery|HTMLElement} target
     * @emits {throwEvent}
     * @private
     * @override
     */
    BSSListBoxComponent.prototype._throwTaggingEvent = function (throwEvent, recalculation, target) {
        var _a, _b, _c;
        if (recalculation === void 0) { recalculation = false; }
        logger.info("BSSListBoxComponent: ".concat(this._config.componentId, " => function : _throwTaggingEvent | Params"), throwEvent, recalculation, target);
        var carId = this._carId || null;
        var modelId = this._modelId || null;
        var productId = this._config.productId[0];
        (_b = (_a = this._toolbox.dxpTagging) === null || _a === void 0 ? void 0 : _a[this._toolbox.currentEntity.entityId]) === null || _b === void 0 ? void 0 : _b.publish(throwEvent, __assign(__assign({}, this._config.resultData[productId]), { carId: carId, modelId: modelId, entity: this._entityTemplate, basicFilters: this._config.basicFilters || null, integrationMode: ((_c = this._toolbox.resultDataFlat[productId]) === null || _c === void 0 ? void 0 : _c.integrationMode) || null }));
    };
    /**
     * @desc prepare initial list box items for models and attach event on load more
     * @private
     */
    BSSListBoxComponent.prototype._prepareListBoxItems = function () {
        logger.info('BSSListBoxComponent: ' +
            this._config.componentId +
            ' => function : _prepareListBoxItems');
        this._$loadMoreBtn = this._$componentEl.find('.bss-load-more_btn-container');
        // load new items only for models
        if (!this._config.isVariantList) {
            var listBoxItems = this._$componentEl.find('.bss-list-box_item');
            listBoxItems
                .slice(0, this._numListBoxItemsOnLoadMore)
                .removeClass('hidden');
            var hiddenListBoxItems = this._$componentEl.find('.bss-list-box_item.hidden');
            if (hiddenListBoxItems.length > 0 && this._$loadMoreBtn.length) {
                this._$loadMoreBtn.removeClass('hidden');
            }
        }
        if (this._$loadMoreBtn.length) {
            this._$loadMoreBtn
                .off('click.' + this._config.componentId)
                .on('click.' + this._config.componentId, this._onLoadMoreClick);
        }
    };
    return BSSListBoxComponent;
}(BSSAbstractComponent));
export default BSSListBoxComponent;
